import { CustomerCaseNewInfoData } from '@/service/customer-new.service'
import { FC } from 'react'
import ProductCard from './product-card.component'
import DownloadCard from '@components/standard/download-card'
import clsx from 'clsx'

interface Section3Props {
  data: {
    productTitle?: string
    products?: CustomerCaseNewInfoData['products']
    downloadTitle?: string
    downloads?: CustomerCaseNewInfoData['downloads']
    downloadMoreTitle?: string
  }
}

const Section3: FC<Section3Props> = ({ data }) => {
  return (
    <div className="w-full bg-white py-15 laptop:py-30">
      <div className="max-w-300 mx-auto flex flex-col gap-y-15 laptop:gap-y-30 px-6 laptop:px-0">
        {/* Product Using */}
        {data.products && data.products?.length > 0 && (
          <div className="flex flex-col">
            <h1 className="text-black/90 text-2xl laptop:text-5xl font-medium mb-8 laptop:mb-16">
              {data.productTitle}
            </h1>
            <div className={clsx('grid gap-4', 'laptop:grid-cols-3')}>
              {data.products?.map((product) => (
                <ProductCard key={product.id} img={product.mediaUrl} name={product.title} jumpUrl={product.jumpUrl} />
              ))}
            </div>
          </div>
        )}
        {/* Download */}
        {data.downloads && data.downloads?.length > 0 && (
          <div className="flex flex-col">
            <h1 className="text-black/90 text-2xl laptop:text-5xl font-medium mb-8 laptop:mb-16">
              {data.downloadTitle}
            </h1>
            <div className="grid laptop:grid-cols-2 gap-4">
              {data.downloads?.map((download) => (
                <DownloadCard
                  key={download.id}
                  img={download.mediaUrl}
                  title={download.title}
                  desc={download.desc}
                  jumpUrl={download.jumpUrl}
                  downloadUrlTitle={data.downloadMoreTitle}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Section3
